var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgE2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      enableBackground: "new 0 0 750 289"
    },
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M750 0H0v289.4h750V0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.9 50.4c-1.1-.4-2.3-.6-3.4-.6-4 .1-6.9 2.2-8.7 6.1l-14.2 36.4 71.9 28 14.2-36.4c1.6-5.6-.2-9.8-5.4-12.3l-54.4-21.2z",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M299.5 84.2c.4-1.3.6-2.5.6-3.8-.2-4.3-2.4-7.5-6.5-9.6l-54.4-21.1c-1.3-.4-2.5-.6-3.8-.6-4.6.2-7.8 2.4-9.6 6.5l-14.2 36.6-.2.8 73.4 28.4.4-.6 14.3-36.6m-1-3.7c0 1-.2 2.1-.6 3.1L284 119.3 213.5 92l13.9-35.9c1.7-3.5 4.4-5.3 8.2-5.4 1 0 2.1.2 3.1.6L293 72.5c3.5 1.6 5.3 4.3 5.5 8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m288.3 76.6-47-18.2-5.4 14.2 47 18.2 5.4-14.2z",
    style: {
      fill: "#fff"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m283.3 91.9 5.9-14.8.2-.8-47.7-18.6-.8-.2-5.9 14.8-.2.8.6.4 47 18.2.9.2m3.9-14.7L282.4 90 237 72.2l4.8-12.5 45.4 17.5zM302 96.7l-.2-1.7-9.6.8.2 1.7 9.6-.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m307.5 92.2-6.5-2.5-5 13 6.5 2.5 5-13z",
    style: {
      fill: "#fff"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m308.5 91.7-.8-.4-6.5-2.5-.8-.2-.2.8-5 13-.4.6.8.4 6.5 2.5.8.4.2-.8 5.2-13 .2-.8m-6.5 12.5-5-2.1 4.4-11.3 5 1.9-4.4 11.5zm-78.6-35L217 62l-1.3 1 6.5 7.3 1.2-1.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m221.3 58.7-6.5-2.5-5.2 13 6.5 2.5 5.2-13z",
    style: {
      fill: "#fff"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m222.3 58-.8-.2-6.5-2.5-.8-.4-.2.8-5 13-.4.8.8.4 6.5 2.5.8.2.2-.8 5-13 .4-.8m-6.6 12.5-5-1.9 4.4-11.5 5 1.9-4.4 11.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m215.4 102.4-7.9 20.7 28.4 16.3 32 7.3 7.9-20.7-60.4-23.6z",
    style: {
      fill: "#999"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m268.7 146.9 7.9-20.7.4-.8-.8-.2-60.4-23.6-.8-.2-.2.8-8.4 21.3.6.4 28.4 16.1h.2l32 7.3.6.2.5-.6m6.2-20.6-7.6 19.3-30.9-7.1-27.8-15.7 7.4-19.3 58.9 22.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m280.3 133.7-15.9-6.1-12.1 31.4 15.7 6 12.3-31.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m280.7 133.5-.4-.2-15.7-6.1-.4-.2-.2.4-12.2 31.6-.2.2.4.2 15.7 6.1.4.2.2-.4 12.1-31.4.3-.4m-13.1 31.2-14.7-6 11.7-30.5 15.1 5.9-12.1 30.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m278.9 133.1-.8-.2-12.1 31.4.6.4 12.3-31.6zm-2.1-.6-.6-.2-12.3 31.4.8.4 12.1-31.6zm-1.5-.6-.8-.4-12.1 31.6.6.2 12.3-31.4zm-1.7-.7-.8-.4-12.3 31.6.8.2 12.3-31.4zm-2-.8-.8-.2-12.1 31.4.8.4 12.1-31.6zm-1.7-.6-.8-.4-12.3 31.6.8.2 12.3-31.4zm-1.7-.7-.8-.4-12.1 31.6.8.2 12.1-31.4zm-1.7-.8-.8-.2-12.3 31.4.8.4 12.3-31.6z",
    style: {
      fill: "#bfbfbf"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m222.1 111.1-15.7-6.1-12.3 31.4 15.7 6.1 12.3-31.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m222.6 110.9-.2-.2-15.9-6.1-.2-.2-.2.4-12.3 31.6v.2l.2.2 15.9 6.1.2.2.2-.4 12.3-31.4v-.4m-13.1 31.2-14.7-5.9 11.9-30.6 14.8 5.9-12 30.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m220.6 110.6-.6-.2-12.3 31.4.8.4 12.1-31.6zm-1.5-.7-.8-.2-12.1 31.4.6.4 12.3-31.6zm-1.9-.6-.6-.4-12.3 31.6.8.2 12.1-31.4zm-1.8-.7-.8-.4-12.1 31.6.6.2 12.3-31.4zm-1.8-.8-.6-.2-12.4 31.4.8.4 12.2-31.6zm-1.7-.6-.8-.4-12.1 31.6.6.2 12.3-31.4zm-1.7-.7-.8-.4-12.4 31.5.8.2 12.4-31.3zm-1.8-.8-.8-.2-12.1 31.4.8.4 12.1-31.6z",
    style: {
      fill: "#bfbfbf"
    }
  }), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M238.4 133c-.6-.3-1.3-.4-2-.4-2.3.1-3.9 1.2-4.9 3.3-.8 3.1.2 5.4 3.1 6.9.6.2 1.3.3 1.9.3 2.2-.1 3.8-1.3 4.8-3.4.9-3.2-.1-5.4-2.9-6.7z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M241.7 139.8c.2-.6.3-1.3.4-2.1-.1-2.4-1.3-4.2-3.6-5.2-.8-.3-1.5-.5-2.1-.4-2.5.1-4.3 1.3-5.4 3.6-.2.8-.3 1.5-.4 2.1.1 2.4 1.4 4.3 3.8 5.4.6.2 1.3.3 2.1.4 2.4-.1 4.2-1.4 5.2-3.8m-5.2-6.9c.6-.1 1.1 0 1.7.2 2 1 3.1 2.5 3.1 4.6.1.6-.1 1.3-.4 1.9-.8 2-2.3 3.1-4.4 3.1-.6 0-1.3-.1-1.9-.4-2-.9-3.1-2.4-3.1-4.6 0-.6.1-1.1.4-1.7.9-1.9 2.4-3 4.6-3.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m233.6 75.2-11.5-4.6-1.9 4.6 11.5 4.6 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m234.6 74.6-.8-.2-12.1-4.8-.4.8-1.9 4.6-.2.8.8.2 11.5 4.4.8.4.2-.8 1.9-4.6.2-.8m-2.2 1-1.1 3.1-9.9-3.8 1.3-3.1 9.7 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m245.1 79.5-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m243.8 85.3 2.3-6.1-.8-.4-11.5-4.4-.6-.4-.4.8-1.7 4.6-.4.8.8.2L243 85l.8.3m.1-5.1-1 2.9-10-3.8 1.3-3 9.7 3.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m256.6 84-11.5-4.4-1.9 4.6 11.5 4.6 1.9-4.8z",
    style: {
      fill: "#ccc"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m257.6 83.6-.8-.2-12.1-4.8-.4.8-1.7 4.6-.4.6.8.4 11.5 4.4.8.4.2-.8 1.9-4.6.2-.8m-2.2.9-1 3.1-9.9-4 1-2.9 9.9 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M268 88.6 256.5 84l-1.9 4.8 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m267.1 93.5 2.1-5.2-.8-.4-11.5-4.4-.6-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.2.2-.8m-.1-4.4-1 3-10-3.8 1.3-3 9.7 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279.5 93 268 88.6l-1.9 4.6 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m280.6 92.5-.8-.2-12.1-4.8-.4.6-1.7 4.8-.4.6.8.4 11.5 4.4.8.4.2-.8 1.9-4.6.2-.8m-2.1.9-1.1 3.1-10-4 1.3-3 9.8 3.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M291.1 97.6 279.6 93l-1.9 4.6 11.5 4.6 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m291.9 97.8.2-.8-12.3-4.6-.6-.4-.4.8-1.7 4.6-.4.8.8.2L289 103l.8.2.2-.8 1.9-4.6m-1.9.1-1.3 3.1-9.9-3.8 1.3-3.1 9.9 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m229.2 68.1-5.4-2.1-1.7 4.6 5.2 2.1 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m230.2 67.7-.8-.4-5.2-2.1-.8-.2-.2.8-1.9 4.6-.2.8 6.7 2.5.4-.8 1.7-4.6.3-.6m-7 2.5 1-3 3.7 1.5-1.1 2.9-3.6-1.4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m240.7 72.5-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m241.7 72.1-.8-.2-11.5-4.6-.8-.2-2.3 6.1.8.4 11.5 4.4.6.4.4-.8 1.7-4.6.4-.9m-2.2.9-1.3 3-9.9-3.9 1.1-2.9 10.1 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m252.2 77.1-11.5-4.6-1.9 4.6 11.5 4.6 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m253.2 76.5-.8-.2-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8.8.2 12.1 4.8.4-.8 1.7-4.6.4-.8m-2.2.9-1.3 3.1-9.8-3.8 1.1-3.1 10 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m263.7 81.5-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m264.7 81.1-.8-.4-11.5-4.4-.8-.2-2.1 5.2-.2.8.8.4 12.1 4.6.4-.6 1.7-4.6.4-.8m-2.2.9-1.3 3-9.8-3.9 1-3.1 10.1 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m275.2 86.1-11.5-4.6-1.9 4.6 11.5 4.6 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m276.2 85.5-.8-.2-11.5-4.6-.8-.2-.2.8-1.9 4.6-.2.8.8.2 11.5 4.4.6.4.4-.8 1.9-4.6.2-.8m-2.2.9-1.3 3.1-9.8-3.8 1.1-3.1 10 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M286.7 90.4 275.2 86l-1.9 4.6 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m285.5 96.1 2.3-6.1-.8-.4-11.5-4.4-.6-.4-.4.8-1.9 4.6-.2.8.8.2 11.5 4.6.8.3m.1-5.1-1 2.9-10-3.8 1.3-3 9.7 3.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m292.9 92.9-6.3-2.5L285 95l6.1 2.5 1.8-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m294 92.3-.8-.2-6.1-2.5-.8-.2-.4.8-1.7 4.6-.4.6.8.4 6.3 2.3.6.4.4-.8 1.7-4.6.4-.8m-7.9 2.2 1.1-2.9 4.6 1.7-1.3 3-4.4-1.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m237.2 65.8-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m238.1 66.3.2-.8-13-5-.4.6-1.7 4.8-.4.6.8.4 11.5 4.4.8.4.2-.8 2-4.6m-1.9.1-1.1 3.1-9.9-4 1.1-2.9 9.9 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m248.7 70.4-11.5-4.6-1.9 4.6 11.5 4.6 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m249.6 70.6.2-.8-12.1-4.6-.8-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.2.2-.8 1.9-4.6m-1.9.1-1.3 3.1-9.9-3.8 1.3-3.1 9.9 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m260.3 74.8-11.5-4.4-1.9 4.6 11.7 4.4 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m259 80.4 2.1-5.2.2-.8-.6-.4-11.5-4.4-.8-.2-.4.6-1.7 4.6-.4.8.8.4 11.5 4.4.8.2m.2-5.1-1.1 3.1-10-4 1.3-3.1 9.8 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m271.8 79.3-11.5-4.6-1.7 4.6 11.5 4.6 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m272.6 79.6.2-.8-12.1-4.8-.8-.2-.4.8-1.7 4.6-.4.8.8.2 11.5 4.4.8.4.2-.8 1.9-4.6m-1.9.1-1.3 3.1-9.9-3.8 1.3-3.1 9.9 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m283.2 83.8-11.5-4.4L270 84l11.5 4.4 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m282 89.3 2.3-6.1-.6-.4-11.5-4.4-.8-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.3m.3-5.1-1.3 3-10-3.9 1.3-3.1 10 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m294.7 88.2-11.5-4.4-1.7 4.6L293 93l1.7-4.8z",
    style: {
      fill: "#ccc"
    }
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m295.6 88.6.2-.8-12.2-4.8-.8-.2-.2.8-1.9 4.6-.4.6.8.4 11.5 4.4.8.4.2-.8 2-4.6m-1.8.1-1.3 3.1-9.9-4 1.1-2.9 10.1 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m232.9 58.9-5.2-2.1-1.9 4.6 5.2 2.1 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m233.9 58.3-.8-.2-5.2-2.1-.8-.2L225 61l-.2.8.8.4 5.2 1.9.8.4.2-.8 1.9-4.6.2-.8m-7.1 2.6 1.1-3 3.8 1.5-1 3-3.9-1.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m244.3 63.3-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m243.1 68.9 2.3-6.1-.8-.4-11.6-4.3-.6-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.9.2m.1-5.1-1 2.9-10-3.8 1.3-3 9.7 3.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m255.8 67.7-11.5-4.4-1.9 4.6 11.5 4.6 1.9-4.8z",
    style: {
      fill: "#ccc"
    }
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m256.9 67.3-.8-.2-12.1-4.8-.4.8-1.7 4.6-.4.6.8.4 11.5 4.4.8.4.2-.8 1.9-4.6.2-.8m-2.2 1-1 3.1-9.9-4 1-2.9 9.9 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m267.3 72.3-11.5-4.6-1.9 4.8 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m266.3 77.1 2.1-5.2-.8-.4-11.6-4.4-.6-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.2.3-.8m-.1-4.4-1 3-10-3.8 1.3-3 9.7 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m278.8 76.7-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m279.9 76.3-.8-.2-12.1-4.8-.4.6-1.7 4.8-.4.6.8.4 11.5 4.4.8.4.2-.8 1.9-4.6.2-.8m-2.1.9-1.1 3.1-10-4 1.3-3 9.8 3.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m290.4 81.2-11.5-4.6-1.9 4.6 11.5 4.6 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m291.2 81.5.2-.8-12.3-4.7-.6-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.2.2-.8 1.9-4.5m-1.9.1-1.3 3.1-9.9-3.8 1.3-3.1 9.9 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m296.6 83.6-6.3-2.3-1.7 4.6 6.1 2.3 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m297.7 83.2-.8-.2-6.1-2.5-.8-.2-2.1 5.2-.2.8.6.4 6.3 2.3.8.4.2-.8 1.9-4.6.2-.8m-8 2.2 1.1-3.1 4.6 1.9-1 3.1-4.7-1.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m240.7 56.6-11.5-4.4-1.7 4.6 11.5 4.4 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m239.4 62.3 2.1-5.2.2-.8-.6-.4-11.5-4.4-.8-.4-.2.8-1.9 4.6-.4.8.8.4 11.5 4.4.8.2m.3-5.1-1.3 3-10-3.9 1.3-3.1 10 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m252.2 61-11.5-4.4-1.7 4.6 11.5 4.6 1.7-4.8z",
    style: {
      fill: "#ccc"
    }
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m253.4 60.6-.8-.2-11.5-4.6-.8-.2-.2.8-1.9 4.6-.4.6.8.4 11.5 4.4.8.4.2-.8 1.9-4.6.4-.8m-2.2.9-1.3 3.1-9.9-4 1.1-2.9 10.1 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M263.7 65.6 252.2 61l-1.7 4.8 11.5 4.4 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m264.9 65.2-.8-.4-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8 12.1 4.8.8.2.2-.8 1.9-4.6.4-.6m-2.3.9-1.1 2.9-10-3.8 1.3-3.1 9.8 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m275.2 69.9-11.5-4.4-1.7 4.6 11.5 4.4 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m276.5 69.5-.8-.2-11.5-4.6-.8-.2-2.3 6.1.6.4 11.5 4.4.8.4.4-.8 1.7-4.6.4-.9m-2.2 1-1.3 3.1-10-4 1.3-3 10 3.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M286.7 74.6 275.2 70l-1.7 4.6 11.5 4.6 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m288 74-.8-.2-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8 12.1 4.8.8.2.4-.8 1.7-4.6.4-.8m-2.2.9-1.3 3.1-9.9-3.8 1.3-3.1 9.9 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m298.4 78.9-11.7-4.4-1.7 4.6 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m299.5 78.6-.8-.4-11.5-4.4-.8-.2-2.1 5.2-.2.8.6.4 11.5 4.4.8.2.4-.6 1.7-4.6.4-.8m-2.2 1-1.3 3.1-9.9-4 1.1-3.1 10.1 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m264.1 125.2-39.7-15.5-6.5 18.2 38.5 15.1 7.7-17.8z",
    style: {
      fill: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.5 133.9-29.9-11.7-2.3 6.1 29.9 11.5 2.3-5.9z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9321 .3625 -.3625 .932 224.057 127.45)",
    style: {
      fontSize: "6.6895px",
      fontFamily: "'ArialMT'"
    }
  }, "\n    L521 GHF\n  "), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m206.6 102.7 75.5 29.3-1.5 9 12.5-37.4L217.3 74l-15.9 36 5.2-7.3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m290.6 104.7-72.3-28-4.6 19.9 66.9 26.1 10-18z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.5 89.9c-1.2-.4-2.4-.6-3.6-.6-4.1.1-7 2.2-8.8 6.1L314 131.7l72.1 28 14.2-36.4c1.5-5.6-.3-9.8-5.4-12.3l-54.4-21.1z",
    style: {
      fill: "#fff"
    }
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M400.9 123.7c.6-1.3.8-2.5.8-3.8-.1-4.5-2.4-7.7-6.7-9.6l-54.4-21.1c-1.3-.4-2.5-.6-3.8-.6-4.4.1-7.6 2.3-9.6 6.5l-14 36.6-.4.6.8.4 71.9 28 .8.2 14.6-37.2m-.8-3.7c0 1-.2 2.1-.6 3.1l-13.9 35.6-70.4-27.4L329 95.7c1.6-3.5 4.3-5.3 7.9-5.4 1 0 2.1.2 3.1.6l54.4 21.1c3.7 1.6 5.6 4.3 5.7 8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m389.9 116.2-47-18.2-5.6 14.2 47 18.2 5.6-14.2z",
    style: {
      fill: "#fff"
    }
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m391 115.7-.8-.4-47-18.2-.6-.4-.4.8-5.4 14.2-.4.8.8.2 47.7 18.6.4-.6 5.4-14.2.3-.8m-2.2.9-4.9 12.5-45.5-17.6 5-12.6 45.4 17.7zm14.6 19.6v-1.7l-9.6.8v1.7l9.6-.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m408.7 131.7-6.5-2.5-5 13 6.5 2.5 5-13z",
    style: {
      fill: "#fff"
    }
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m409.6 131.9.4-.6-.8-.4-6.5-2.5-.8-.2-5.6 14.4.8.4 6.5 2.5.8.2 5.2-13.8m-6.3 11.6-4.9-1.9 4.4-11.3 4.9 1.9-4.4 11.3zm-78.6-34.8-6.3-7.1-1.3 1 6.3 7.1 1.3-1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m322.6 98.2-6.5-2.7-5 13.2 6.5 2.5 5-13z",
    style: {
      fill: "#fff"
    }
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m323.5 98.4.2-.8-7.1-2.7-.8-.4-.4.8-5 13-.2.8 7.9 3.1.4-.8 5-13m-6.4 11.6-4.8-1.9 4.4-11.5 4.8 1.9-4.4 11.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m317.3 142.1-7.9 20.7 28.4 16.1 32 7.3 7.9-20.7-60.4-23.4z",
    style: {
      fill: "#999"
    }
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m370.7 186.5 7.9-20.7.4-.6-.8-.4-60.4-23.4-.8-.4-.2.8-8.4 21.3.6.4 28.4 16.1.2.2 32 7.3.6.2.5-.8m6-20.4-7.4 19.1-31-7.1-27.8-15.7 7.4-19.3 58.8 23z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m382.1 173.2-15.9-6.1-12.2 31.6 15.7 6.1 12.4-31.6z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m382.5 173.1-.4-.2-15.7-6.1h-.4l-.2.2-12.1 31.6-.2.4h.4l15.7 6.3h.4l.2-.2 12.1-31.6.2-.4m-13.1 31.1-14.8-5.7 11.9-30.7 15.1 5.9-12.2 30.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m380.6 172.9-.8-.4-12.2 31.5.6.2 12.4-31.3zm-1.8-.9-.6-.2-12.3 31.6.8.2 12.1-31.6zm-1.7-.6-.8-.2-12.1 31.4.6.4 12.3-31.6zm-1.8-.7-.8-.4-12.3 31.6.8.2 12.3-31.4zm-1.8-.5-.8-.4-12.1 31.6.8.2 12.1-31.4zm-1.6-.9-.8-.2-12.3 31.4.8.4 12.3-31.6zm-2-.6-.8-.2-12.1 31.4.8.4 12.1-31.6zm-1.7-.6-.8-.4-12.4 31.5.8.2 12.4-31.3z",
    style: {
      fill: "#bfbfbf"
    }
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m324 150.6-15.7-6.1-12.3 31.6 15.7 6.1 12.3-31.6z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m324.3 150.5-.2-.2-15.9-6.1h-.2l-.2.2-12.3 31.6v.4h.2l15.9 6.3h.2l.2-.2 12.3-31.6v-.4m-13.1 31.1-14.8-5.7 12.1-30.6 14.8 5.7-12.1 30.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m322.5 150.3-.6-.4-12.3 31.6.8.2 12.1-31.4zm-1.7-.9-.8-.2-12.1 31.6.6.2 12.3-31.6zm-1.9-.6-.6-.2L306 180l.8.4 12.1-31.6zm-1.6-.6-.8-.4-12.1 31.6.6.2 12.3-31.4zm-1.9-.6-.6-.4-12.3 31.6.8.2 12.1-31.4zm-1.7-.9-.8-.2-12.1 31.4.6.4 12.3-31.6zm-1.8-.6-.6-.2-12.3 31.3.8.4 12.1-31.5zm-1.7-.6-.8-.4-12.1 31.6.6.2 12.3-31.4z",
    style: {
      fill: "#bfbfbf"
    }
  }), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M340.2 172.4c-.6-.3-1.3-.4-1.9-.4-2.4.1-4 1.2-5 3.3-.9 3.1.1 5.4 3.1 6.9.7.2 1.4.3 2 .3 2.2-.1 3.8-1.1 4.7-3.2 1-3.2 0-5.5-2.9-6.9z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M343.6 179.6c.2-.8.3-1.5.4-2.1-.1-2.5-1.3-4.3-3.6-5.4-.8-.2-1.5-.3-2.1-.4-2.6.1-4.4 1.4-5.4 3.8-.2.6-.3 1.3-.4 2.1.1 2.4 1.3 4.2 3.8 5.2.6.2 1.3.3 2.1.4 2.4-.2 4.2-1.4 5.2-3.6m-5.2-7.1c.6 0 1.1.1 1.7.4 2 .8 3.1 2.4 3.1 4.6.1.5-.1 1-.4 1.7-.8 2-2.3 3.1-4.4 3.1-.6 0-1.3-.1-1.9-.4-2-.8-3.1-2.3-3.1-4.4 0-.6.1-1.3.4-1.9.9-2 2.4-3 4.6-3.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m335.5 114.7-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m334.4 119.7 2.1-5.4-.8-.4-11.5-4.4-.6-.4-.4.8-1.9 4.6-.2.8.8.2 12.1 4.8.4-.6m-.1-4.5-1.1 2.9-9.9-3.8 1.3-3 9.7 3.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m347 119.1-11.5-4.4-1.9 4.6 11.5 4.6 1.9-4.8z",
    style: {
      fill: "#ccc"
    }
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m348 118.7-.8-.2-12.1-4.8-.4.8-2.1 5.2.8.4 11.5 4.4.8.4.2-.8 1.9-4.6.2-.8m-2.2 1-1 3.1-9.9-4 1-2.9 9.9 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m358.5 123.7-11.5-4.6-1.9 4.8 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m357.4 128.5 2.1-5.2-.8-.4-11.5-4.4-.6-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.2.2-.8m-.1-4.3-1 2.9-10-3.8 1.3-3 9.7 3.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m370 128.1-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "m371.1 127.7-.8-.2-12.1-4.8-.4.6-1.7 4.8-.4.6.8.4 11.5 4.4.8.4.2-.8 1.9-4.6.2-.8m-2.1 1-1.1 3.1-10-4 1.1-2.9 10 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m381.5 132.7-11.5-4.6-1.9 4.6 11.5 4.6 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m382.6 132.1-.8-.2-11.5-4.4-.6-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.2.2-.8 1.9-4.6.2-.8m-2.1.9-1.3 3.1-9.9-3.8 1.3-3.1 9.9 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m393 137-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m391.8 142.8 2.1-5.2.2-.8-.8-.4-11.5-4.4-.6-.4-.4.8-1.7 4.6-.4.8.8.4 11.5 4.4.8.2m.2-5.1-1.1 2.9-10-3.8 1.3-3.1 9.8 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m331.1 107.6-5.4-2.1-1.7 4.8 5.2 1.9 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m332.1 107.2-.8-.2-5.2-2.1-.8-.4-.2.8-1.9 4.6-.2.8 6.1 2.3.6.4.4-.8 1.7-4.6.3-.8m-7.1 2.6 1.1-3.1 3.8 1.5-1.3 3.1-3.6-1.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m342.6 112.2-11.5-4.6-1.9 4.6 11.5 4.6 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "m343.7 111.6-.8-.2-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8.8.2 12.1 4.8.4-.8 1.7-4.6.4-.8m-2.2.9-1.3 3.1-9.9-3.8 1.3-3.1 9.9 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m354.1 116.6-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m355.1 116.2-.8-.4-11.5-4.4-.8-.2-2.1 5.2-.2.8.8.4 12.1 4.6.4-.6 1.7-4.6.4-.8m-2.2.9-1.3 3-9.9-3.9 1.1-3.1 10.1 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m365.6 121.1-11.5-4.6-1.9 4.6 11.5 4.6 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m366.6 120.5-.8-.2-11.5-4.6-.8-.2-.2.8-1.9 4.6-.2.8.8.2 11.5 4.4.6.4.4-.8 1.7-4.6.4-.8m-2.2 1-1.3 3.1-9.8-3.8 1.1-3.1 10 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m377.1 125.6-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "m376 130.6 2.1-5.4-.8-.4-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8.8.2 12.1 4.8.4-.6m-.2-4.5-1 2.9-9.9-3.8 1-3.1 9.9 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m388.6 130-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "m389.6 129.6-.8-.2-12.1-4.8-.4.6-2.1 5.4.8.4 11.5 4.4.8.4.2-.8 1.9-4.6.2-.8m-2.2.9-1.3 3-9.7-3.9 1-2.9 10 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m394.7 132.5-6.3-2.5-1.7 4.8 6.1 2.3 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m395.9 132-.8-.4-6.1-2.3-.8-.4-.4.8-1.7 4.6-.4.8.8.2 6.9 2.7.4-.6 1.7-4.8.4-.6m-8 2.2 1.3-3.1 4.6 1.9-1.3 2.9-4.6-1.7z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m338.9 105.5-11.5-4.6-1.9 4.6 11.5 4.6 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "m340 104.9-.8-.2-11.5-4.4-.6-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.2.2-.8 1.9-4.6.2-.8m-2.1.9-1.1 3.1-10-3.8 1.3-3.1 9.8 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m350.4 109.9-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m349.2 115.5 2.1-5.2.2-.8-.6-.4-12.3-4.6-.4.6-1.7 4.6-.4.8.8.4 11.5 4.4.8.2m.2-5.1-1.1 3.1-10-4 1.3-3.1 9.8 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m361.9 114.5-11.5-4.6-1.9 4.6 11.7 4.6 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "m362.8 114.8.2-.8-12.1-4.8-.8-.2-.4.8-1.7 4.6-.4.8.8.2 11.5 4.4.8.4.2-.8 1.9-4.6m-1.9.1-1.1 3.1-10-3.8 1.3-3.1 9.8 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m373.5 118.8-11.5-4.4-1.7 4.6 11.5 4.4 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "m372.2 124.6 2.3-6.1-.6-.4-11.5-4.4-.8-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.3m.2-5.1-1.1 2.9-10-3.8 1.3-3.1 9.8 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m385 123.3-11.5-4.4-1.7 4.6 11.5 4.6 1.7-4.8z",
    style: {
      fill: "#ccc"
    }
  }), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "m385.8 123.7.2-.8-12.1-4.8-.8-.2-.4.8-1.7 4.6-.4.6.8.4 11.5 4.4.8.4.2-.8 1.9-4.6m-1.9.1-1.1 3.1-9.9-4 1.1-2.9 9.9 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m396.5 127.8-11.5-4.6-1.7 4.8 11.5 4.4 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "m397.3 128.1.2-.8-12.1-4.6-.8-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.2.2-.8 1.9-4.6m-1.9.3-1.1 2.9-10-3.8 1.3-3.1 9.8 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m334.7 98.4-5.2-2.1-1.9 4.6 5.2 2.1 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "m335.7 98-.8-.4-5.2-2.1-.8-.2-.2.8-1.9 4.6-.2.8.8.2 5.9 2.3.4-.6 2-5.4m-7 2.6 1-3.1 3.8 1.5-1.1 2.9-3.7-1.3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m346.1 102.8-11.5-4.4-1.9 4.6 11.5 4.6 1.9-4.8z",
    style: {
      fill: "#ccc"
    }
  }), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "m347.2 102.4-.8-.2-12.1-4.8-.4.8-2.1 5.2.8.4 11.5 4.4.8.4.2-.8 1.9-4.6.2-.8m-2.2.9-1 3.1-9.9-4 1-2.9 9.9 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m357.7 107.3-11.5-4.6-1.9 4.8 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "m356.6 112.2 2.1-5.2-.8-.4-11.5-4.4-.6-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.2.2-.8m-.1-4.3-1 2.9-10-3.8 1.3-3 9.7 3.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m369.2 111.8-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "m370.2 111.4-.8-.4-12.1-4.6-.4.6-1.7 4.8-.4.6.8.4 11.5 4.4.8.4.2-.8 1.9-4.6.2-.8m-2.1.9-1.1 3.1-10-4 1.1-2.9 10 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m380.7 116.4-11.5-4.6-1.9 4.6 11.5 4.6 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "m381.7 115.8-.8-.2-12.1-4.8-.4.8-1.7 4.6-.4.8.8.2 11.5 4.4.8.4.2-.8 1.9-4.6.2-.8m-2.1.9-1.3 3.1-9.9-3.8 1.3-3.1 9.9 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m392.2 120.7-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "m390.9 126.4 2.3-6.1-.6-.4-11.7-4.4-.6-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.3m.2-5.1-1.1 2.9-10-3.8 1.3-3.1 9.8 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m398.3 123.3-6.3-2.5-1.7 4.6 6.1 2.5 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "m399.4 122.7-.8-.2-6.1-2.5-.8-.2-.2.8-1.9 4.6-.2.8 6.9 2.7.8.2.2-.8 1.9-4.6.2-.8m-8.1 2.4 1.3-3.1 4.6 1.7-1.1 3.1-4.8-1.7z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m342.6 96.1-11.5-4.4-1.7 4.6 11.5 4.6 1.7-4.8z",
    style: {
      fill: "#ccc"
    }
  }), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "m343.5 96.6.2-.8-12.1-4.8-.8-.2-.4.8-1.7 4.6-.4.6.8.4 11.5 4.4.8.4.2-.8 1.9-4.6m-1.8.1-1.3 3.1-9.9-4 1.1-2.9 10.1 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m354.1 100.7-11.5-4.6-1.7 4.8 11.5 4.4 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "m353 105.5 2.1-5.2-.6-.4-11.5-4.4-.8-.4-.2.8-1.9 4.6-.4.8.8.2 11.5 4.6.8.2.2-.8m0-4.3-1.1 2.9-10-3.8 1.3-3.1 9.8 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m365.6 105-11.5-4.4-1.7 4.6 11.5 4.4 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "m366.8 104.6-.8-.2-11.5-4.6-.8-.2-2.3 6.1.6.4 11.5 4.4.8.4.2-.8 1.9-4.6.4-.9m-2.2 1-1.3 3.1-10-4 1.3-3 10 3.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m377.1 109.6-11.5-4.6-1.7 4.6 11.5 4.6 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "m378.4 109.1-.8-.2-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8 12.1 4.8.8.2.4-.8 1.7-4.6.4-.8m-2.2 1-1.3 3.1-10-3.8 1.3-3.1 10 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m388.6 114.1-11.5-4.4-1.7 4.6 11.5 4.4 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "m389.9 113.7-.8-.4-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8.6.4 11.5 4.4.8.2.4-.6 1.7-4.6.4-.8m-2.2.9-1.3 3-9.9-3.9 1.1-3.1 10.1 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m400 118.4-11.5-4.4-1.7 4.6 11.5 4.6 1.7-4.8z",
    style: {
      fill: "#ccc"
    }
  }), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "m401.2 118-.8-.2-11.5-4.6-.9-.2-.2.8-1.9 4.6-.2.8 12.1 4.6.8.4.4-.8 1.7-4.6.5-.8m-2.2 1-1.3 3.1-9.8-3.9 1.1-3 10 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m338.1 89.2-5.2-2.1-1.9 4.6 5.2 2.1 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "m338.9 89.4.2-.8-6.7-2.5-.4.6-2.1 5.4.8.4 5.2 2.1.8.2.2-.8 2-4.6m-6.8 1.8 1.1-2.9 3.7 1.3-1 3.1-3.8-1.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m349.6 93.6-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "m348.3 99.2 2.1-5.2.2-.8-.6-.4-11.5-4.4-.8-.2-.4.6-1.7 4.6-.4.8.8.4 11.5 4.4.8.2m.2-5.1-1.1 3.1-10-4 1.3-3.1 9.8 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m361.1 98.2-11.5-4.6-1.9 4.6 11.7 4.6 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "m361.9 98.5.2-.8-12.1-4.9-.8-.2-.4.8-1.7 4.6-.4.8.8.2 11.5 4.4.8.4.2-.8 1.9-4.5m-1.9.1-1.3 3.1-9.9-3.8 1.3-3.1 9.9 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m372.8 102.6-11.5-4.4-1.7 4.6 11.5 4.4 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "m371.3 108.2 2.3-6.1-.6-.4-11.5-4.4-.8-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.3m.1-5.2-1 3-10-3.8 1.3-3.1 9.7 3.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m384.2 107-11.5-4.4-1.7 4.6 11.5 4.4 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "m385 107.5.2-.8-12.1-4.8-.8-.2-.4.6-1.7 4.8-.4.6.8.4 11.5 4.4.8.4.2-.8 1.9-4.6m-1.8.1-1.3 3.1-9.9-4 1.1-2.9 10.1 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m395.7 111.6-11.5-4.6-1.7 4.6 11.5 4.6 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "m396.5 111.8.2-.8-12.1-4.6-.8-.4-.2.8-1.9 4.6-.4.8.8.2 11.5 4.6.8.2.2-.8 1.9-4.6m-1.8.1-1.3 3.1-10-3.8 1.3-3.1 10 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m402 113.9-6.1-2.3-1.9 4.6 6.1 2.3 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "m402.8 114.3.2-.8-6.9-2.7-.8-.2-2.3 6.1.8.4 6.1 2.3.8.4.2-.8 1.9-4.7m-7.7 1.4 1.1-2.9 4.6 1.7-1 3.1-4.7-1.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m346.1 86.9-11.5-4.4-1.7 4.6 11.5 4.4 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "m347.3 86.5-.8-.4-11.5-4.4-.8-.2-2.1 5.2-.2.8.6.4 11.5 4.4.8.2.4-.6 1.7-4.6.4-.8m-2.2 1-1.3 3.1-9.9-4 1.1-3.1 10.1 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m357.8 91.5-11.7-4.6-1.7 4.6 11.5 4.6 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "m358.8 90.9-.8-.2-11.5-4.6-.8-.2-.2.8-1.9 4.6-.2.8 12.1 4.6.8.4.4-.8 1.7-4.6.4-.8m-2.2.9-1.3 3.1-9.9-3.8 1.3-3.1 9.9 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m369.2 95.8-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "m370.3 95.5-.8-.4-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8 13 5 .4-.6 1.7-4.8.3-.6m-2.2 1-1.3 3-9.9-3.9 1.1-3.1 10.1 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m380.7 100.2-11.5-4.4-1.9 4.6 11.5 4.6 1.9-4.8z",
    style: {
      fill: "#ccc"
    }
  }), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "m381.8 99.8-.8-.2-11.6-4.6-.8-.2-.2.8-2.1 5.2.8.4 11.5 4.4.6.4.4-.8 1.7-4.6.5-.8m-2.2.9-1.3 3.1-9.8-3.9 1-3 10.1 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m392.3 104.9-11.5-4.6-1.9 4.8 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "m393.3 104.5-.8-.4-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8.8.2 12.1 4.8.4-.8 1.7-4.6.4-.6m-2.3.9-1.1 2.9-9.9-3.8 1.1-3.1 9.9 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m403.8 109.3-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "m404.8 108.9-.8-.4-11.5-4.4-.8-.2-2.1 5.2-.2.8.8.4 11.5 4.4.6.4.4-.8 1.7-4.6.4-.8m-2.2.9-1.3 3-9.8-3.9 1-2.9 10.1 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m341.8 79.8-5.2-1.9-1.9 4.6 5.4 2.1 1.7-4.8z",
    style: {
      fill: "#ccc"
    }
  }), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "m342.6 80.2.2-.8-5.9-2.3-.8-.4-.4.8-1.7 4.6-.4.8.8.2 5.2 2.1.8.4.2-.8 2-4.6m-6.8 1.8 1.3-3.1 3.8 1.5-1.3 3.1-3.8-1.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m353.2 84.4-11.5-4.6-1.7 4.8 11.5 4.4 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "m354.6 84-.8-.4-11.5-4.4-.8-.4-.2.8-1.9 4.6-.4.8.8.2 11.5 4.6.8.2.2-.8 1.9-4.6.4-.6m-2.3.9-1.1 2.9-10-3.8 1.3-3.1 9.8 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m364.8 88.8-11.5-4.4-1.7 4.6 11.5 4.4 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "m366 88.4-.8-.2-11.5-4.6-.8-.2-2.3 6.1.6.4 11.5 4.4.8.4.2-.8 1.9-4.6.4-.9m-2.2 1-1.3 3.1-10-4 1.3-3 10 3.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m376.3 93.4-11.5-4.6-1.7 4.6 11.5 4.6 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "m377.5 92.8-.8-.2-11.5-4.4-.8-.4-.2.8-1.9 4.6-.3.8 12.1 4.8.9.2.4-.8 1.7-4.6.4-.8m-2.2.9-1.3 3.1-10-3.8 1.3-3.1 10 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m387.8 97.7-11.5-4.4-1.7 4.6 11.5 4.4 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "m389 97.4-.8-.4-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8.6.4 11.5 4.4.8.2.4-.6 1.7-4.6.4-.8m-2.2 1-1.3 3-9.9-3.9 1.1-3.1 10.1 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m399.5 102.1-11.7-4.4-1.7 4.6 11.5 4.6 1.9-4.8z",
    style: {
      fill: "#ccc"
    }
  }), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "m400.5 101.7-.8-.2-11.5-4.6-.8-.2-.2.8-2.1 5.2.6.4 11.5 4.4.8.4.4-.8 1.7-4.6.4-.8m-2.2.9-1.3 3.1-9.8-3.9 1.1-3 10 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m405.5 104.7-6.1-2.3-1.9 4.6 6.3 2.3 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "m406.8 104.3-.8-.4-6.3-2.3-.6-.4-.4.8-1.9 4.6-.2.8.8.2 6.1 2.5.8.2 2.1-5.2.4-.8m-8.1 2.2 1.3-3 4.6 1.8-1.3 3-4.6-1.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m349.9 77.3-11.5-4.4-1.7 4.6 11.5 4.4 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "m351.2 76.9-.8-.4-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8.6.4 11.5 4.4.8.2.4-.6 1.7-4.8.4-.6m-2.2 1-1.3 3-10-3.9 1.3-3.1 10 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M361.5 81.7 350 77.3l-1.7 4.6 11.5 4.6 1.7-4.8z",
    style: {
      fill: "#ccc"
    }
  }), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "m362.7 81.3-.8-.2-11.5-4.6-.8-.2-.2.8-2.1 5.2.6.4 11.5 4.4.8.4.4-.8 1.7-4.6.4-.8m-2.2.9-1.3 3.1-9.8-3.9 1-3 10.1 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m373.1 86.3-11.7-4.6-1.7 4.8 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "m374.2 85.9-.8-.4-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8 12.1 4.8.8.2.4-.8 1.7-4.6.4-.6m-2.3.9-1.1 2.9-9.9-3.8 1.1-3.1 9.9 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m384.6 90.7-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "m385.6 90.3-.8-.2-11.5-4.6-.8-.2-2.3 6.1.6.4 11.5 4.4.8.4.4-.8 1.7-4.6.4-.9m-2.2.9-1.3 3.1-9.9-4 1.1-2.9 10.1 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m396 95.3-11.5-4.6-1.9 4.6 11.5 4.6 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "m397.1 94.7-.8-.2-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8 13 5 .4-.8 1.7-4.6.3-.8m-2.2.9-1.3 3.1-9.9-3.8 1.3-3.1 9.9 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M407.5 99.6 396 95.2l-1.9 4.6 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "m408.6 99.2-.8-.4-11.5-4.4-.8-.2-2.1 5.2-.2.8.8.4 12.1 4.6.4-.6 1.7-4.6.4-.8m-2.2 1-1.3 3.1-9.9-4 1.1-3.1 10.1 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m345.4 70.2-5.2-2.1-1.9 4.8 5.4 1.9 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "m346.2 70.6.2-.8-6.1-2.3-.6-.4-.4.8-1.7 4.6-.4.8.8.2 5.2 2.1.8.4.2-.8 2-4.6m-6.8 1.8 1.3-3.1 3.7 1.5-1.1 3.1-3.9-1.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m357 74.8-11.5-4.6-1.7 4.6 11.5 4.6 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "m357.8 75 .2-.8-12.1-4.6-.8-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.2.2-.8 1.9-4.6m-1.8.1-1.3 3.1-10-3.8 1.3-3.1 10 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M368.5 79.1 357 74.8l-1.7 4.6 11.5 4.4 1.7-4.7z",
    style: {
      fill: "#ccc"
    }
  }), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "m367.2 84.8 2.1-5.2.2-.8-.6-.4-11.5-4.4-.8-.2-2.1 5.2-.4.8.8.4 11.5 4.4.8.2m.3-5.1-1.3 3.1-10-4 1.3-3.1 10 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m380.1 83.7-11.5-4.6-1.7 4.6 11.5 4.6 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "m381.3 83.1-.8-.2-11.5-4.6-.8-.2-.2.8-1.9 4.6-.2.8 12.1 4.6.8.4.2-.8 1.9-4.6.4-.8m-2.2.9-1.3 3.1-10-3.8 1.3-3.1 10 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m391.6 88.2-11.5-4.4-1.7 4.6 11.5 4.4 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "m392.8 87.8-.8-.4-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8 12.1 4.8.8.2.4-.6 1.7-4.8.4-.6m-2.3.9-1.1 2.9-10-3.8 1.3-3.1 9.8 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m403 92.5-11.5-4.4-1.7 4.6 11.5 4.4 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "m404.3 92.1-.8-.2-11.5-4.6-.8-.2-2.3 6.1.6.4L401 98l.8.4.4-.8 1.7-4.6.4-.9m-2.2 1-1.3 3.1-9.8-3.9 1-3 10.1 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m409.3 95.1-6.1-2.5-1.9 4.8 6.3 2.3 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "m410.3 94.6-.6-.4-6.3-2.3-.8-.4-.2.8-1.9 4.6-.2.8.8.2 6.1 2.5.8.2 2.3-6m-7.8 2.2 1-3.1 4.7 1.9-1.1 2.9-4.6-1.7z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m366 164.6-39.7-15.5-6.5 18.2 38.5 15.1 7.7-17.8z",
    style: {
      fill: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357.4 173.4-29.9-11.5-2.3 5.9 29.9 11.7 2.3-6.1z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9321 .3625 -.3625 .932 325.907 167.1)",
    style: {
      fontSize: "6.6895px",
      fontFamily: "'ArialMT'"
    }
  }, "\n    L521 GHF\n  "), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "m308.5 142.3 75.5 29.5-1.5 8.8 12.5-37.4-75.9-29.5-15.9 36 5.3-7.4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m392.6 144.4-72.3-28.2-4.6 20.1 66.9 25.9 10-17.8z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.1 129.5c-1.1-.4-2.3-.6-3.4-.6-4 .1-6.9 2.2-8.7 6.1l-14.2 36.4 71.9 28 14.2-36.4c1.6-5.6-.2-9.8-5.4-12.3l-54.4-21.2z",
    style: {
      fill: "#fff"
    }
  }), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M502.8 163.2c.4-1.3.6-2.5.6-3.8-.2-4.4-2.4-7.6-6.5-9.6l-54.4-21.1c-1.3-.4-2.5-.6-3.8-.6-4.6.1-7.8 2.3-9.6 6.5L415 171.2l-.2.8 72.8 28.2.8.2 14.4-37.2m-1.1-3.7c0 1-.2 2.1-.6 3.1l-13.7 35.9-70.7-27.4 13.9-35.9c1.7-3.5 4.4-5.3 8.2-5.4 1 0 2.1.2 3.1.6l54.4 21.1c3.5 1.6 5.3 4.3 5.4 8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m491.6 155.7-47-18.2-5.4 14.2 47 18.2 5.4-14.2z",
    style: {
      fill: "#fff"
    }
  }), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "m486.6 170.9 5.9-14.8.2-.8-47.7-18.6-.8-.2-5.9 14.8-.2.8.6.4 47 18.2.9.2m3.8-14.7-4.8 12.8-45.4-17.8 4.8-12.5 45.4 17.5zm14.9 19.6-.2-1.7-9.6.8.2 1.7 9.6-.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m510.6 171.2-6.5-2.5-5 13 6.5 2.5 5-13z",
    style: {
      fill: "#fff"
    }
  }), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "m511.7 170.8-.8-.4-6.5-2.5-.8-.2-.2.8-5 13-.4.8.8.2 6.5 2.5.8.4.2-.8 5.2-13 .2-.8m-6.5 12.4-5-1.9 4.4-11.5 5 1.9-4.4 11.5zm-78.5-35-6.5-7.1-1.3 1 6.5 7.3 1.3-1.2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m424.6 137.7-6.5-2.5-5.2 13 6.5 2.5 5.2-13z",
    style: {
      fill: "#fff"
    }
  }), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "m425.6 137.1-.8-.2-6.5-2.5-.8-.4-.2.8-5 13-.4.8.8.4 6.5 2.5.8.2.2-.8 5-13 .4-.8m-6.6 12.5-5-1.9 4.4-11.5 5 1.9-4.4 11.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m419.1 181.6-7.9 20.7 28.4 16.1 32 7.3 7.9-20.7-60.4-23.4z",
    style: {
      fill: "#999"
    }
  }), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "m472 226.7 8.4-21.3.4-.8-.8-.2-60.4-23.6-.8-.2-8.6 22.2.6.2 28.4 16.3h.2l32 7.3.6.1m6.6-21.2-7.5 19.1-31.3-7.1v.1L412.2 202l7.4-19.2 59 22.7z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "m483.6 212.9-15.7-6.3-12.1 31.6 15.7 6.1 12.1-31.4z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "m484.3 212.7-.4-.2-15.7-6.1-.4-.2-.2.4-12.1 31.4-.2.4.4.2 15.7 6.1.4.2.2-.4 12.1-31.6.2-.2m-13 31.1-14.8-5.7 11.8-30.8 14.9 6-11.9 30.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m482.4 212.3-.8-.2-12.1 31.4.6.4 12.3-31.6zm-1.8-.6-.6-.4-12.3 31.6.8.2 12.1-31.4zm-1.7-.6-.8-.4-12.1 31.5.6.2 12.3-31.3zm-1.7-.9-.8-.2-12.4 31.4.8.4 12.4-31.6zm-1.8-.6-.8-.2-12.1 31.4.8.4 12.1-31.6zm-1.8-.6-.8-.4-12.3 31.6.8.2 12.3-31.4zm-1.7-.8-.9-.2-12.1 31.4.8.4 12.2-31.6zm-1.9-.7-.8-.2-12.3 31.4.8.4 12.3-31.6z",
    style: {
      fill: "#bfbfbf"
    }
  }), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "m425.7 190.4-15.7-6.3-12.3 31.6 15.7 6.1 12.3-31.4z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "m426.3 190.2-.2-.2-15.9-6.1-.4-.2v.4l-12.3 31.4-.2.4.4.2 15.9 6.1.2.2.2-.4 12.3-31.6v-.2m-13 31.1-14.8-5.9 11.8-30.7 14.9 6-11.9 30.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m424.3 189.7-.8-.2-12.1 31.4.8.4 12.1-31.6zm-1.6-.6-.8-.4-12.3 31.6.8.2 12.3-31.4zm-2-.6-.6-.4-12.3 31.6.8.2 12.1-31.4zm-1.7-.9-.8-.2-12.2 31.4.6.4 12.4-31.6zm-1.7-.6-.6-.2-12.3 31.4.8.4 12.1-31.6zm-1.8-.6-.8-.4-12.1 31.6.6.2 12.3-31.4zm-1.8-.8-.6-.2-12.3 31.4.8.4 12.1-31.6zm-1.6-.7-.8-.2-12.1 31.4.6.4 12.3-31.6z",
    style: {
      fill: "#bfbfbf"
    }
  }), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M442.1 211.8c-.6-.2-1.3-.3-1.9-.3-2.4.1-4 1.2-5 3.4-1 3.1 0 5.4 2.9 6.9.6.3 1.3.4 1.9.3 2.4-.1 4-1.2 5-3.4.9-3.1-.1-5.4-2.9-6.9z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M445.4 219c.3-.7.4-1.4.4-2.1-.1-2.4-1.3-4.2-3.6-5.2-.8-.3-1.5-.5-2.1-.4-2.5.1-4.3 1.3-5.4 3.6-.2.7-.3 1.4-.4 2.1.1 2.5 1.4 4.3 3.8 5.2.6.3 1.3.5 2.1.4 2.5 0 4.2-1.2 5.2-3.6m-5.2-6.9c.4-.1 1 0 1.7.2 2 1 3.1 2.6 3.1 4.6 0 .7-.1 1.3-.4 1.7-.8 2.1-2.3 3.1-4.4 3.1-.6.1-1.3 0-1.9-.2-2-1-3-2.5-3.1-4.6.1-.6.2-1.2.4-1.7.9-2 2.4-3.1 4.6-3.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m437.2 154.2-11.5-4.4-1.9 4.6 11.5 4.6 1.9-4.8z",
    style: {
      fill: "#ccc"
    }
  }), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "m438.3 153.8-.8-.2L426 149l-.8-.2-.2.8-2.1 5.2.8.4 11.5 4.4.6.4.4-.8 1.9-4.6.2-.8m-2.2 1-1.3 3-9.8-3.9 1-2.9 10.1 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m448.7 158.8-11.5-4.6-1.9 4.8 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "m447.7 163.6 2.1-5.2-.8-.4-11.5-4.4-.6-.4-.4.8-1.9 4.6-.2.8.8.2 11.5 4.6.8.2.2-.8m-.1-4.3-1 2.9-10-3.8 1.3-3 9.7 3.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m460.2 163.2-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "m461.2 162.8-.8-.4-12.1-4.6-.4.6-1.7 4.8-.4.6.8.4 11.5 4.4.8.4.2-.8 1.9-4.6.2-.8m-2.2.9-1 3.1-10-4 1.1-2.9 9.9 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m471.7 167.8-11.5-4.6-1.9 4.6 11.5 4.6 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "m472.7 167.2-.8-.2-12.1-4.8-.4.8-1.7 4.6-.4.8.8.2 11.5 4.4.8.4.2-.8 1.9-4.6.2-.8m-2.2 1-1 3.1-10-3.8 1.3-3.1 9.7 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m483.2 172.1-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "m481.9 177.8 2.3-6.1-.8-.4-11.5-4.4-.6-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.3m.2-5.1-1.1 2.9-10-3.8 1.3-3 9.8 3.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m494.7 176.6-11.5-4.4-1.9 4.6 11.5 4.6 1.9-4.8z",
    style: {
      fill: "#ccc"
    }
  }), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "m495.8 176.2-.8-.2-12.1-4.8-.4.8-1.7 4.6-.4.6.8.4 11.5 4.4.8.4.2-.8 1.9-4.6.2-.8m-2.1.9-1.1 3.1-9.9-4 1.1-2.9 9.9 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m432.9 147.2-5.4-2.1-1.7 4.6 5.2 2.1 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "m433.9 146.7-.8-.2-5.2-2.1-.8-.2-2.3 6.1.6.4 6.1 2.3.4-.8 1.7-4.6.3-.9m-7.2 2.6 1.3-3 3.8 1.4-1.3 3.1-3.8-1.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m444.4 151.6-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "m445.5 151.3-.8-.4-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8.8.4 12.1 4.6.4-.6 1.7-4.6.4-.8m-2.2 1-1.3 3-9.9-3.9 1.1-3.1 10.1 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m455.9 156.1-11.5-4.4-1.9 4.6 11.5 4.6 1.9-4.8z",
    style: {
      fill: "#ccc"
    }
  }), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "m456.9 155.7-.8-.2-11.5-4.6-.8-.2-.2.8-2.1 5.2.8.4 11.5 4.4.6.4.4-.8 1.7-4.6.4-.8m-2.2 1-1.3 3-9.8-3.8 1.1-3 10 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m467.4 160.7-11.5-4.6-1.9 4.8 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "m468.5 160.3-.8-.4-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8.8.2 12.1 4.8.4-.8 1.7-4.6.4-.6m-2.3.9-1 2.9-9.9-3.8 1-3.1 9.9 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m478.9 165.1-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "m480 164.6-.8-.2-11.5-4.6-.8-.2-2.3 6.1.8.4 11.5 4.4.6.4.4-.8 1.7-4.6.4-.9m-2.2 1-1.3 3-9.8-3.9 1-2.9 10.1 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m490.4 169.6-11.5-4.6-1.9 4.6 11.5 4.6 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "m491.5 169.1-.8-.2-11.5-4.4-.8-.4-.2.8-1.9 4.6-.2.8.8.2 12.1 4.8.4-.8 1.9-4.6.2-.8m-2.2 1-1.3 3.1-9.8-3.8 1.1-3.1 10 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m496.6 172-6.3-2.3-1.7 4.6 6.1 2.3 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "m497.7 171.6-.8-.2-6.1-2.5-.8-.2-.4.6-1.7 4.8-.4.6.8.4 6.3 2.3.6.4.4-.8 1.7-4.6.4-.8m-8 2.2 1.3-3 4.6 1.8-1.3 3.1-4.6-1.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m440.9 145-11.5-4.4-1.9 4.6 11.5 4.4 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "m439.6 150.7 2.1-5.2.2-.8-.8-.4-12.1-4.6-.4.6-1.7 4.6-.4.8.8.4 11.5 4.4.8.2m.2-5.1-1.1 3.1-10-4 1.3-3.1 9.8 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m452.4 149.6-11.5-4.6-1.9 4.6 11.5 4.6 1.9-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "m453.2 149.8.2-.8-13-5-.4.8-1.7 4.6-.4.8.8.2 11.5 4.4.8.4.2-.8 2-4.6m-1.9.1-1.1 3.1-10-3.8 1.3-3.1 9.8 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m463.8 154-11.5-4.4-1.9 4.6 11.7 4.4 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "m462.6 159.6 2.3-6.1-.6-.4-11.5-4.4-.8-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.3m.1-5.2-1 3-10-3.8 1.3-3.1 9.7 3.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m475.3 158.5-11.5-4.4-1.7 4.6 11.5 4.4 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "m476.2 158.9.2-.8-12.1-4.8-.8-.2-.4.6-1.7 4.8-.4.6.8.4 11.5 4.4.8.4.2-.8 1.9-4.6m-1.9.1-1.1 3.1-9.9-4 1.1-2.9 9.9 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m486.8 163-11.5-4.6-1.7 4.6 11.5 4.6 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "m487.7 163.3.2-.8-12.1-4.6-.8-.4-.4.8-1.7 4.6-.4.8.8.2 11.5 4.6.8.2.2-.8 1.9-4.6m-1.9.1-1.1 3.1-10-3.8 1.3-3.1 9.8 3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m498.3 167.4-11.5-4.4-1.7 4.6 11.5 4.4 1.7-4.6z",
    style: {
      fill: "#ccc"
    }
  }), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "m497.1 173 2.1-5.2.2-.8-.6-.4-11.5-4.4-.8-.2-.4.6-1.7 4.6-.4.8.8.4 11.5 4.4.8.2m.3-5.1-1.3 3.1-10-4 1.3-3.1 10 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m467.8 204.2-39.7-15.5-6.5 18.4 38.5 15.1 7.7-18z",
    style: {
      fill: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m459.1 213.3-29.9-11.7-2.3 6.1 29.9 11.5 2.3-5.9z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9321 .3625 -.3625 .932 427.707 206.6)",
    style: {
      fontSize: "6.6895px",
      fontFamily: "'ArialMT'"
    }
  }, "\n    L521 GHF\n  "), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "m410.2 182 75.5 29.3-1.5 8.8 12.5-37.2-75.9-29.5-15.9 36 5.3-7.4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M494.4 183.8 422 155.6l-4.6 20.1 66.9 26.1 10.1-18z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.5 259.6v-12.3H479.1l-292.2-114H82.6v126.3h634.9z",
    style: {
      fill: "#ccc"
    }
  }), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M717.5 248.2v-1.7H479.1v.1l-291.9-114H82.6v1.7h104.1l292.1 113.9h238.7z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M388.2 46.7c-2.5-2.6-5.6-3.8-9.2-3.9-3.6 0-6.7 1.3-9.3 3.9-2.6 2.6-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.3 2.6 2.6 5.7 3.9 9.3 3.9 3.6 0 6.7-1.3 9.2-3.9 2.6-2.5 3.9-5.6 3.9-9.3 0-3.6-1.3-6.7-3.9-9.3z",
    style: {
      fill: "#369",
      fillOpacity: 0.502
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.998 0 0 1 374.904 61.254)",
    style: {
      fontSize: "12.2472px",
      fontFamily: "'ArialMT'",
      fill: "#fff"
    }
  }, "\n    2\n  "), /*#__PURE__*/React.createElement("path", {
    d: "M284.9 32.7c-2.5-2.6-5.6-3.8-9.2-3.9-3.6 0-6.7 1.3-9.3 3.9-2.6 2.6-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.3 2.6 2.6 5.7 3.9 9.3 3.9 3.6 0 6.7-1.3 9.2-3.9 2.6-2.5 3.9-5.6 3.9-9.3 0-3.6-1.3-6.7-3.9-9.3z",
    style: {
      fill: "#369",
      fillOpacity: 0.502
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.998 0 0 1 271.604 47.254)",
    style: {
      fontSize: "12.2472px",
      fontFamily: "'ArialMT'",
      fill: "#fff"
    }
  }, "\n    1\n  "), /*#__PURE__*/React.createElement("path", {
    d: "M487.7 107.9c-2.5-2.6-5.6-3.8-9.2-3.9-3.6 0-6.7 1.3-9.3 3.9-2.6 2.6-3.9 5.7-3.9 9.3 0 3.6 1.3 6.7 3.9 9.3 2.6 2.6 5.7 3.9 9.3 3.9 3.6 0 6.7-1.3 9.2-3.9 2.6-2.5 3.9-5.6 3.9-9.3 0-3.6-1.3-6.7-3.9-9.3z",
    style: {
      fill: "#369",
      fillOpacity: 0.502
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.998 0 0 1 474.404 122.454)",
    style: {
      fontSize: "12.2472px",
      fontFamily: "'ArialMT'",
      fill: "#fff"
    }
  }, "\n    3\n  "));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE2);
export default __webpack_public_path__ + "static/media/e2.d298ba13729776e35a0c8d041610decb.svg";
export { ForwardRef as ReactComponent };